export default __webpack_public_path__ + "static/media/Icon-Arrow_Gain.e9eef62c.svg";